import { render, staticRenderFns } from "./MessageContentBubble.vue?vue&type=template&id=5a6bfb64&scoped=true&"
import script from "./MessageContentBubble.vue?vue&type=script&lang=js&"
export * from "./MessageContentBubble.vue?vue&type=script&lang=js&"
import style0 from "./MessageContentBubble.vue?vue&type=style&index=0&id=5a6bfb64&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6bfb64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VImg,VRow,VSheet,VSpacer})
